import { union } from "lodash";

// Merges an entity summary into a running list, combining manufacturers,
// products, ndcs and row counts when the entity already exists.
const mergeEntityInto = (entityList, entity) => {
  const existing = entityList.find((e) => e.id_340b === entity.id_340b);

  if (existing) {
    existing.manufacturers = [...new Set([...entity.manufacturers, ...existing.manufacturers])];
    existing.products = [...new Set([...entity.products, ...existing.products])];
    existing.rowCount = existing.rowCount + entity.rowCount;

    for (const [ndc, ndcDetails] of Object.entries(entity.ndcs)) {
      if (existing.ndcs[ndc]) {
        existing.ndcs[ndc].rows += ndcDetails.rows;
      } else {
        existing.ndcs[ndc] = { ...ndcDetails };
      }
    }
  } else {
    entityList.push({
      ...entity,
      manufacturers: [...entity.manufacturers],
      products: [...entity.products],
      ndcs: Object.fromEntries(Object.entries(entity.ndcs).map(([k, v]) => [k, { ...v }])),
      errors: [...(entity.errors || [])],
      warnings: [...(entity.warnings || [])],
    });
  }
};

const buildSummaryData = (attachmentsData) => {
  const allManufacturers = new Set();
  const summaryData = {
    rows: 0,
    valid: 0,
    original: 0,
    manufacturers: 0,
    products: [],
    files: 0,
    entities: [],
    excludedEntities: [],
    excludedRows: 0,
  };

  for (const attachment of attachmentsData) {
    summaryData.files++;
    summaryData.rows += attachment.selectedRows;
    summaryData.valid += attachment.summary.valid;
    summaryData.original += attachment.totalRows;
    summaryData.excludedRows += attachment.summary.excludedRowCount ?? 0;
    summaryData.products = union(summaryData.products, attachment.summary.products);
    for (const mfr of Object.keys(attachment.summary.manufacturers ?? {})) {
      allManufacturers.add(mfr);
    }

    for (const entity of attachment.summary.entities) {
      mergeEntityInto(summaryData.entities, entity);
    }

    for (const entity of attachment.summary.excludedEntities ?? []) {
      mergeEntityInto(summaryData.excludedEntities, entity);
    }
  }

  summaryData.manufacturers = allManufacturers.size;
  return summaryData;
};

export default buildSummaryData;
